import { createContext } from 'react';

export const DocumentTypesContext = createContext([]);